const routes = {
  path: 'inquiries',
  component: () => import('@/modules/obu-inquiries/index.vue'),
  children: [
    {
      path: ':type',
      name: 'obu-inquiries',
      component: () => import('@/modules/obu-inquiries/ObuInquiriesList.vue'),
      children: [
        {
          path: 'points',
          name: 'obu-inquiries-points',
          component: () => import('@/modules/obu-inquiries/ObuInquiriesPoints.vue')
        }
      ]
    },
    {
      path: ':type/:id',
      name: 'obu-inquiries-details',
      component: () => import('@/modules/obu-inquiries/ObuInquiriesDetails.vue'),
      children: []
    }
  ]
}

export default routes
